import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {BASE_URL} from './helper'

export default function Login() {
  const navigate = useNavigate()
  const [credentials, setcredentials] = useState({ email: "", password: "" })

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${BASE_URL}/api/loginuser`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: credentials.email, password: credentials.password })
    });
    const json = await response.json()
    console.log(json);
    if (!json.success) {
      alert("Enter vailed credentials")
    }
    if (json.success) {
      localStorage.setItem("userEmail", credentials.email);
      localStorage.setItem("authToken", json.authToken);
      console.log(localStorage.getItem("authToken"));
      navigate("/")
    }
  }

  const onchange = (event) => {
    setcredentials({ ...credentials, [event.target.name]: event.target.value })
  }

  return (
    <>
      <div className='container'>
        <form onSubmit={handleSubmit}>
          <div className="m-3">
            <label htmlFor="exampleInputEmail1">Email address</label>
            <input type="email" className="form-control" onChange={onchange} placeholder="Enter email" name='email' value={credentials.email} />                    </div>
          <div className="m-3">
            <label htmlFor="exampleInputPassword1">Password</label>
            <input type="password" className="form-control" onChange={onchange} placeholder="Password" name='password' value={credentials.password} />
          </div>
          <button type="submit" className=" m-3 btn btn-primary">Submit</button>
          <Link className="m-3 btn btn-success" to="/Signup">New user register</Link>
        </form>
      </div>
    </>
  )
}
